import { FunctionComponent } from 'react';
import { classNames } from '../utilities/styles';
import Link from 'next/link';

type TabsProps = {
  tabs: string[];
  currentTab: string;
};

const Tabs: FunctionComponent<TabsProps> = ({ tabs, currentTab }) => {
  return (
    <div className="mt-6 sm:mt-2 2xl:mt-5">
      <div>
        <div className="max-w-5xl px-4 mx-auto sm:px-6 lg:px-8">
          <nav className="flex -mb-px space-x-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <Link href={`#${tab.toLocaleLowerCase()}`} key={tab}>
                <a
                  className={classNames(
                    tab === currentTab
                      ? 'border-techy-green text-friendly-egg'
                      : 'border-transparent text-friendly-egg hover:text-techy-green hover:border-techy-green',
                    'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'
                  )}
                  aria-current={tab === currentTab ? 'page' : undefined}
                >
                  {tab}
                </a>
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Tabs;
